import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";

function AdminStoreRegister() {
    const inputs = useRef([]);
    const searchRef = useRef();
    const selectRef = useRef();
    const { t } = useTranslation();

    const id = 'root';
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState();
    const [selectedVendorId, setSelectedVendorId] = useState();



    const signUp = () => {

        let data = { storeName: "", vendorId: "" }
        validateInputs(inputs.current).then((isValid) => {
            if (isValid) {
                // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                data.storeName = inputs.current[0].getValue();
                data.storeCode = inputs.current[1].getValue();
                data.vendorId = selectedVendorId;
                if (!selectedVendorId) {
                    toast.error(t("점주를 선택해주세요"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                    return;
                } else {
                    dispatch(HistoryReducer.actions.setLoading(true));
                    requester.createStore(data, (result) => {
                        if (result.code === 0) {
                            
                            toast.success(t("등록이 완료되었습니다."), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            })
                        } else {
                            toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                        dispatch(HistoryReducer.actions.setLoading(false));
                    });
                }


                // 이후 데이터 처리 로직...
            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

            }
        })



    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const search = () => {
        
        let data = { userName: searchRef.current.getValue() }
        requester.searchVendor(data, (result) => {
            setSearchResults(result.data);
        })

    }
    const handleSelectChange = (e) => {
        
        setSelectedVendorId(e.target.value); // 선택된 값으로 상태 업데이트
    };


    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <div>
                            <P size={40} font={"gmarketSansBold"} color={"black"}>스토어 등록</P>
                        </div>
                    </FlexChild>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>매장명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"매장명"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>점주찾기 : </P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <InputText ref={searchRef} placeHolder={"점주 ID 검색"} />
                                    </FlexChild>
                                    <FlexChild>
                                        <CustomButton text={"검색"} style={btnStyle} onClick={search} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {
                        searchResults &&
                        searchResults.length > 0 && (
                            <FlexChild>
                                <select onChange={handleSelectChange} ref={selectRef} value={selectedVendorId}>
                                    <option value={""}>선택하세요</option>
                                    {searchResults.map((vendor, index) => (
                                        <option key={index} value={vendor.id}>
                                            {vendor.userName}
                                        </option>
                                    ))}
                                </select>
                            </FlexChild>
                        )
                    }
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상점 코드 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상점코드"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"점주등록"} style={btnStyle} onClick={signUp} />
                    </FlexChild>
                </VerticalFlex>


            </Container>
        </Container>
    );
}

export default AdminStoreRegister;